module.exports = __webpack_public_path__ + "static/claims3-b4a7732c638931cc400d5ab6adfdf90f.svg";